import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-the-h01-point-achievement-panel",
  "aria-label": "ポイント実績"
}
const _hoisted_2 = { class: "p-the-h01-point-achievement-panel__items" }
const _hoisted_3 = { class: "p-the-h01-point-achievement-panel__item" }
const _hoisted_4 = { class: "p-the-h01-point-achievement-panel__label" }
const _hoisted_5 = {
  class: "p-the-h01-point-achievement-panel__point",
  "data-translate-skip": ""
}
const _hoisted_6 = { class: "p-the-h01-point-achievement-panel__point__value" }
const _hoisted_7 = {
  key: 0,
  class: "p-the-h01-point-achievement-panel__item"
}
const _hoisted_8 = { class: "p-the-h01-point-achievement-panel__label" }
const _hoisted_9 = {
  class: "p-the-h01-point-achievement-panel__point",
  "data-translate-skip": ""
}
const _hoisted_10 = { class: "p-the-h01-point-achievement-panel__point__value" }
const _hoisted_11 = { class: "p-the-h01-point-achievement-panel__point__unit" }
const _hoisted_12 = {
  key: 1,
  class: "p-the-h01-point-achievement-panel__item"
}
const _hoisted_13 = { class: "p-the-h01-point-achievement-panel__label" }
const _hoisted_14 = {
  class: "p-the-h01-point-achievement-panel__point",
  "data-translate-skip": ""
}
const _hoisted_15 = { class: "p-the-h01-point-achievement-panel__point__value" }
const _hoisted_16 = { class: "p-the-h01-point-achievement-panel__point__unit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInvested = _resolveComponent("IconInvested")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconGive = _resolveComponent("IconGive")!
  const _component_IconGiven = _resolveComponent("IconGiven")!

  return (_ctx.pointAchievement)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_IconBase, {
                class: "p-the-h01-point-achievement-panel__icon",
                "view-box": "0 0 40 40",
                width: 32,
                height: 32
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconInvested, { "icon-color": _ctx.colorCode }, null, 8, ["icon-color"])
                ]),
                _: 1
              }),
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "付与されたポイント", -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.addComma(_ctx.cumulativeGrantedPoints)), 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "p-the-h01-point-achievement-panel__point__unit" }, " ポイント ", -1))
            ])
          ]),
          (_ctx.thanksPointEnabled && _ctx.isGroupBudget === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_IconBase, {
                    class: "p-the-h01-point-achievement-panel__icon",
                    "view-box": "0 0 40 40",
                    width: 32,
                    height: 32
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconGive, { "icon-color": _ctx.colorCode }, null, 8, ["icon-color"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, "贈った" + _toDisplayString(_ctx.thanksPointName), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.addComma(_ctx.pointAchievement.cumulativePointsToSend)), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.pointName), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.thanksPointEnabled && _ctx.isGroupBudget === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_IconBase, {
                    class: "p-the-h01-point-achievement-panel__icon",
                    "view-box": "0 0 40 40",
                    width: 32,
                    height: 32
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconGiven, { "icon-color": _ctx.colorCode }, null, 8, ["icon-color"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, "受け取った" + _toDisplayString(_ctx.thanksPointName), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.addComma(_ctx.pointAchievement.cumulativeThanksPoints)), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.pointName), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}